"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addInteractiveElementsForReadingPane_1 = require("./utils/addInteractiveElementsForReadingPane");
exports.addInteractiveElementsForReadingPane = addInteractiveElementsForReadingPane_1.default;
var SharingAcceptButton_1 = require("./components/SharingAcceptButton");
exports.SharingAcceptButton = SharingAcceptButton_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/lazyIndex.js
// module id = 5801
// module chunks = 96